import { Link } from 'react-router';
import { TrustpilotBadge } from '../TrustpilotBadge';
import { useSocialMediaAccounts } from '@/hooks/useSocialMedia';
import { SocialIcon } from '@/components/icons/SocialIcon';

export const Footer = () => {
    const { data: socialAccounts } = useSocialMediaAccounts();

    return (
        <footer className="bg-footer" aria-labelledby="footer-heading">
            <h2 id="footer-heading" className="sr-only">
                Footer
            </h2>
            <div className="mx-auto max-w-7xl px-6 pb-8 pt-16 sm:pt-24 lg:px-8 lg:pt-32">
                <div className="xl:grid xl:grid-cols-3 xl:gap-8">
                    <div className="space-y-8">
                        <Link to="/" aria-label="Stork Rentals - Go to homepage">
                            <img
                                src="/assets/images/logo/TSELogoFull.png"
                                alt="Stork Rentals"
                                className="h-10 w-auto brightness-0 invert"
                                width="158"
                                height="40"
                            />
                        </Link>
                        <p className="text-sm leading-6 text-white/70">
                            Premium baby equipment rentals and subscriptions for families on the move or close to home. Clean, safe, and easy to arrange.
                        </p>
                        {/* Trustpilot Badge */}
                        <TrustpilotBadge
                            rating={4.8}
                            ratingText="Excellent"
                            size="sm"
                            theme="dark"
                            className="-ml-2"
                        />
                        <div className="flex space-x-6">
                            {socialAccounts?.map((account) => (
                                <a
                                    key={account.id}
                                    href={account.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex h-11 w-11 items-center justify-center rounded-full text-white/50 hover:bg-white/5 hover:text-white/70 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-300"
                                    aria-label={account.displayLabel}
                                >
                                    <SocialIcon platform={account.platform} className="h-6 w-6" />
                                </a>
                            ))}
                        </div>
                    </div>
                    <div className="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
                        <div className="md:grid md:grid-cols-2 md:gap-8">
                            <div>
                                <h3 className="text-sm font-semibold leading-6 text-white">Solutions</h3>
                                <ul role="list" className="mt-6 space-y-4">
                                    <li>
                                        <Link to="/catalogue" className="text-sm leading-6 text-white/70 hover:text-white">
                                            Catalogue
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/how-it-works" className="text-sm leading-6 text-white/70 hover:text-white">
                                            How It Works
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="mt-10 md:mt-0">
                                <h3 className="text-sm font-semibold leading-6 text-white">Support</h3>
                                <ul role="list" className="mt-6 space-y-4">
                                    <li>
                                        <Link to="/contact" className="text-sm leading-6 text-white/70 hover:text-white">
                                            Contact Us
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/faq" className="text-sm leading-6 text-white/70 hover:text-white">
                                            FAQ
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="md:grid md:grid-cols-2 md:gap-8">
                            <div>
                                <h3 className="text-sm font-semibold leading-6 text-white">Company</h3>
                                <ul role="list" className="mt-6 space-y-4">
                                    <li>
                                        <Link to="/about" className="text-sm leading-6 text-white/70 hover:text-white">
                                            About
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/locations" className="text-sm leading-6 text-white/70 hover:text-white">
                                            Locations
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="mt-10 md:mt-0">
                                <h3 className="text-sm font-semibold leading-6 text-white">Legal</h3>
                                <ul role="list" className="mt-6 space-y-4">
                                    <li>
                                        <Link to="/terms" className="text-sm leading-6 text-white/70 hover:text-white">
                                            Terms & Conditions
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/privacy" className="text-sm leading-6 text-white/70 hover:text-white">
                                            Privacy Policy
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/rental-agreement" className="text-sm leading-6 text-white/70 hover:text-white">
                                            Rental Agreement
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-16 border-t border-white/10 pt-8 sm:mt-20 lg:mt-24">
                    <p className="text-xs leading-5 text-white/50">
                        &copy; {new Date().getFullYear()} Stork Rentals. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};
